;(function module() {
  'use strict'

  angular
    .module('app.ui.form.ctrls')
    .controller('RecommendationPageController', [
      '$scope',
      '$location',
      '$window',
      '$uibModal',
      'PositionApi',
      'SharedApi',
      'userService',
      function controller(
        $scope,
        $location,
        $window,
        $uibModal,
        PositionApi,
        SharedApi,
        userService
      ) {
        let vm = this

        vm.toggle = {}
        vm.source = {}
        vm.tabDescription = 1
        vm.initializeListing = {}
        vm.setTab = (tabId, value) => {
          vm.tab = tabId
          if (value !== 'Description' || value !== `Source`)
            vm.initializeListingGrid()

          if (value === 'Matches') {
            vm.toggle.recommendationListing = true
            vm.toggle.applicationListing = false
            vm.toggle.description = false
          } else if (value === 'Applications') {
            vm.toggle.recommendationListing = false
            vm.toggle.applicationListing = true
            vm.toggle.description = false
          } else if (value === 'Description') {
            vm.toggle.description = true
            vm.toggle.applicationListing = false
            vm.toggle.recommendationListing = false
          } else {
            $window.open('https://www.linkedin.com', '_blank')
          }
        }

        vm.isSet = tabId => {
          return vm.tab === tabId
        }

        vm.showModalTab = tabId => {
          vm.tabDescription = tabId
        }

        vm.isModalSet = tabId => {
          return vm.tabDescription === tabId
        }

        vm.tabSwitch = value => {
          vm.toggle.recommendationListing = value
        }

        // Vm.openEditJob = positionId => {
        //   $window.open(
        //     '/admin/job-edit?job=' + positionId + '&isClone=false',
        //     '_blank'
        //   )
        // }

        vm.openEditJob = () => {
          // eslint-disable-next-line no-alert
          alert(
            'This feature has been disabled. Please use the pencil icon to edit the position.'
          )
        }

        vm.openHelpDescriptionModal = () => {
          const helpModalInstance = $uibModal.open({
            templateUrl: 'help-description-modal.html',
            controller: 'RecommendationHelpDescriptionModalController',
            controllerAs: 'ctrl',
            resolve: {
              isModalSet: function() {
                return vm.isModalSet
              },
              showModalTab: function() {
                return vm.showModalTab
              },
            },
          })
          helpModalInstance.result.then(
            () => {
              helpModalInstance.dismiss()
            },
            () => {}
          )
        }

        vm.matchingLawyerDescription = positionRecord => {
          if (
            positionRecord.professionId === 'tech' ||
            !positionRecord.lawPreferences
          ) {
            positionRecord.lawPreferences = {
              minPqe:
                positionRecord.techPreferences &&
                positionRecord.techPreferences.minExperience
                  ? positionRecord.techPreferences.minExperience
                  : -2,
              maxPqe: 11,
            }
          }

          let employerSelectivity = ''
          if (positionRecord.employer.selectivity) {
            for (
              let index = 1;
              index <= positionRecord.employer.selectivity;
              index++
            ) {
              employerSelectivity += '$'
            }
          }

          if (positionRecord.employer.selectivity === 0)
            employerSelectivity = 'Uncategorized'

          vm.recommendationPositionDescription = {
            employer: {
              id: positionRecord.employer.id,
              name: positionRecord.employer.name,
              selectivity: employerSelectivity,
            },
            id: positionRecord.id,
            title: positionRecord.title,
            created: positionRecord.created,
            lawPreferences: {
              minPqe: positionRecord.lawPreferences.minPqe,
              maxPqe: positionRecord.lawPreferences.maxPqe,
            },
            pqe: `${positionRecord.lawPreferences.minPqe};${positionRecord.lawPreferences.maxPqe}`,
            contractType: vm.contractTypesList.find(
              contract => contract.id === positionRecord.contractTypeId
            ).name,
            occupation: vm.occupationList.find(
              occupation => occupation.id === positionRecord.occupationId
            ).name,
            locations:
              positionRecord.locations.length > 0
                ? vm.locationsList
                    .filter(({id}) =>
                      positionRecord.locations.find(
                        location => location.id === id
                      )
                    )
                    .map(location => ({
                      id: location.id,
                      name: location.name,
                      parent: location.parent,
                      color: location.country.region.color,
                    }))
                : [],
            specialties:
              positionRecord.specialties.length > 0
                ? vm.legalPracticeAreaList.specialties.filter(({id}) =>
                    positionRecord.specialties.find(
                      specialty => specialty.id === id
                    )
                  )
                : [],
            expiresAt: positionRecord.expiresAt,
            minPQE: positionRecord.lawPreferences.minPqe
              ? positionRecord.lawPreferences.minPqe
              : -2,
            maxPQE: positionRecord.lawPreferences.maxPqe
              ? positionRecord.lawPreferences.maxPqe
              : 11,
            visible: positionRecord.visible,
            status: positionRecord.expiresAt
              ? new Date(positionRecord.expiresAt).setHours(0, 0, 0, 0) <=
                new Date().setHours(0, 0, 0, 0)
                ? `Expired`
                : `Active`
              : 'Active',
            description: positionRecord.description,
            externalUrl: positionRecord.externalUrl,
            type: positionRecord.type,
          }
        }

        // Vm.openEditPositionPage = id => {
        //   $window.open(`/admin/job-edit?job=${id}&isClone=false`, '_blank')
        // }

        vm.openEditPositionPage = () => {
          // eslint-disable-next-line no-alert
          alert(
            'This feature has been disabled. Please use the pencil icon to edit the position.'
          )
        }

        vm.openPositionDetailModal = () => {
          $uibModal.open({
            templateUrl: 'position-details-modal.html',
            windowClass: 'position-modal-window',
            controller: 'PositionDetailsController',
            controllerAs: 'ctrl',
            resolve: {
              position: function() {
                return vm.recommendationPositionDescription
              },
              listingName: function() {
                return 'recommendation'
              },
            },
          })
        }

        vm.editPositionModal = id => {
          const modalInstance = $uibModal.open({
            templateUrl: 'create-update-position-modal.html',
            windowClass: 'app-firm-window',
            controller: 'CreateUpdatePositionModalController',
            controllerAs: 'ctrl',
            resolve: {
              selectedPositionId: function() {
                return id
              },
              adminId: function() {
                return vm.user.id
              },
            },
          })
          modalInstance.result.then(
            position => {
              modalInstance.dismiss('cancel')
            },
            () => {}
          )
        }

        vm.positionStatusColor = selectedPosition => {
          return selectedPosition &&
            selectedPosition.expiresAt &&
            new Date(selectedPosition.expiresAt).setHours(0, 0, 0, 0) <=
              new Date().setHours(0, 0, 0, 0)
            ? {background: 'Red'}
            : {background: 'Yellow'}
        }

        vm.pageStyle = () => {
          return {
            height: `${vm.innerHeight - 120}px`,
            width: `100%`,
          }
        }

        vm.setLocationColor = color => {
          if (color) {
            return {
              background: color,
            }
          }
        }

        vm.initializeListingGrid = () => {
          if (vm.tab === 1 && !vm.initializeListing.recommendation) {
            vm.initializeListing.recommendation = true
            vm.source.matchesSource = `/admin/matching-lawyers-listing?positionId=${vm.positionId}&employerId=${vm.employerId}&innerHeight=${vm.innerHeight}`
          }

          if (vm.tab === 2 && !vm.initializeListing.application) {
            vm.initializeListing.application = true
            vm.source.applicationsSource = `/admin/application-listing?positionId=${vm.positionId}&innerHeight=${vm.innerHeight}`
          }
        }

        vm.loadRecommendationPage = async () => {
          vm.user = await userService.getUser()
          vm.positionId = $location.search().positionId
          vm.employerId = $location.search().employerId
          // eslint-disable-next-line angular/window-service
          vm.innerHeight = window.innerHeight
          vm.tab = Number($location.search().tab)
          vm.tab = vm.tab ? vm.tab : 1
          vm.setTab(vm.tab, getTabType(vm.tab))
          const [
            {data: positionRecord, status: positionStatus},
            {data: locationsList},
            {data: contractTypeList},
            {data: occupationList},
            {data: legalPracticeAreaList},
          ] = await Promise.all([
            PositionApi.getPositionById(vm.positionId),
            SharedApi.getAllLocations({
              regions: true,
            }),
            SharedApi.getAllContractTypes(),
            SharedApi.getAllOccupations(),
            SharedApi.getCategoryById(1),
          ])
          if (positionStatus === 200) {
            vm.selectedPosition = positionRecord

            vm.contractTypesList = contractTypeList
            vm.occupationList = occupationList
            vm.legalPracticeAreaList = legalPracticeAreaList
            vm.locationsList = locationsList
            vm.employerLogo = vm.selectedPosition.employer.logo
              ? `${process.env.PUBLIC_BUCKET_URL}/employers/${vm.selectedPosition.employer.id}/logo/${vm.selectedPosition.employer.logo}`
              : undefined
            vm.matchingLawyerDescription(vm.selectedPosition)
            $scope.$apply()
          }
        }

        vm.loadRecommendationPage()
      },
    ])
})()

const getTabType = id => {
  switch (id) {
    case 1:
      return 'Matches'
    case 2:
      return 'Applications'
    case 3:
      return 'Description'
    default:
      break
  }
}



// WEBPACK FOOTER //
// ./scripts/admin-panel/recommendation-listing/recommendation-page.ctrl.js